import api, { unwrap } from './client';

// EPT prévisionnel (Planification personnel) : { months: {1..12}, avg }.
export const getPlannedFte = (tenantId, year) =>
  unwrap(api.get(`/hr/planning/${tenantId}/${year}/fte`));
